module.exports = __webpack_public_path__ + "static/media/value8.e8a94c92.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/value8.webp
// module id = 221
// module chunks = 0